export const MYSQL_URL_REGEX =
  /\/\/(.+):(.+)@(.*?)(?::(\d+))?\/([\w|-]+)\??(ssl=.+)?/;

export const buildMysqlConnectionUrl = ({
  username,
  password,
  hostname,
  port,
  database,
  sslOptions,
}) => {
  const user = username || "";
  const pass = password || "";
  const host = hostname || "";
  const prt = port || "";
  const db = database || "";
  const ssl = sslOptions || "";

  // nothing meaningful entered (port alone has a default) → keep the field empty
  if (!user && !pass && !host && !db && !ssl) {
    return "";
  }

  return `mysql://${user}:${pass}@${host}${prt ? `:${prt}` : ""}/${db}${
    ssl ? `?ssl=${ssl}` : ""
  }`;
};

/** Parse a mysql:// connection URL into its parts; null when it doesn't match. */
export const parseMysqlConnectionUrl = (connectionString) => {
  const match = connectionString?.match(MYSQL_URL_REGEX);
  if (!match) {
    return null;
  }

  const [, username, password, hostname, port, database, ssl] = match;
  return {
    username,
    password,
    hostname,
    port,
    database,
    sslOptions: ssl?.replace("ssl=", "") || "",
  };
};
